/**
 * Reader's own light/dark choice on a published docs portal.
 *
 * The owner's `theme` setting is only the *default* for first-time visitors. Once a
 * reader flips the switcher, their choice wins on every later visit — it is their
 * reading comfort, not the owner's branding.
 *
 * Keyed per space so each portal keeps its own default until that portal is
 * explicitly overridden.
 */

const PREFIX = 'doctree:docs-theme:';

const keyFor = (spaceId) => `${PREFIX}${spaceId || 'unknown'}`;

/**
 * 'dark' | 'light' | null (null = reader has never chosen, so use the owner default).
 * Storage can throw in private mode or a partitioned iframe; treat that as "no choice".
 */
export function readDocsThemePreference(spaceId) {
  try {
    const v = window.localStorage.getItem(keyFor(spaceId));
    return v === 'dark' || v === 'light' ? v : null;
  } catch {
    return null;
  }
}

export function writeDocsThemePreference(spaceId, isDark) {
  try {
    window.localStorage.setItem(keyFor(spaceId), isDark ? 'dark' : 'light');
  } catch {
    /* storage unavailable — preference just won't persist */
  }
}
